export const ChargeWaiverConstant = {

    Title: {
        WAIVER_APPLICATION: "Waiver Application",
        SUBMIT: "Submit",
        REVERSE: "Withdraw",
        REJECT: "Reject",
        APPROVE: "Approve",
        PENDING_APPROVAL: "Pending for Approval",
        PENDING_SUBMIT: "Pending for Update",
        UPDATE: "Update Waiver",
        REVERSE_REASON: "Withdraw Reason",
        REJECT_REASON: "Reject Reason",
        MORE: "More",
        BULK_EDIT: "Bulk Edit",
    },
    Search: {
        SEARCH_CRITERIA: "Search Criteria",
        CONTAINER_NO: "Container No.",
        VESSEL_CODE: "Vessel Code",
        VOYAGE_CODE: "Voyage Code",
        CONSORTIUM_CODE: "Consortium Code",
        WAIVER_REASON: "Waiver Reason",
        ETD: "ETD",
        SHIPPING_BILL: "Shipping Bill / Bill Of Lading",
    },

    Table: {
        SEQ_NO: "Seq. No",
        CONTAINER_NO: "Container No.",
        WAIVER_REASON: "Waiver Reason",
        CHARGE_TYPE: "Charge Type",
        SUB_CHARGE_TYPE: "Sub Charge Type",
        STATUS: "Status",
        SIZE: "Size",
        TYPE: "Type",
        CHARGE_ON_COMPANY: "Charge-On Company",
        BILL_TO_COMPANY: "Bill-To Company",
        CONSORTIUM_CODE: "Consortium Code",
        VESSEL_CODE: "Vessel Code",
        VOYAGE_CODE: "Voyage Code",
        CUSTOMER_NAME: "Customer Name",
        ETD: "ETD",
        CONTAINER_TYPE_GROUP: "Container Type Group",
        SERVICE_ORDER_CODE: "Service Order Code",
        TARIFF_TYPE: "Tariff Type",
        TARIFF_CODE: "Tariff Code",
        CHARGING_FROM_DATE_TIME: "Charging From Date/Time",
        CHARGING_TO_DATA_TIME: "Charging To Date/Time",
        CHARGE_QTY: "Charge Qty",
        UOM: "UOM",
        OPS_LINE: "Ops Line",
        TRUCKER_NAME: "Trucker Name",
        CNIC_NO: "CNIC No",
        VEHICLE_NO: "Vehicle No",
        NATURE: "Nature",
        DAMAGE_TYPE: "Damage Type",
        AMOUNT: "Amount",
        REMARKS: "Remarks",
        COMMODITY_CODE: "Commodity Code",
        FORWARDER_SHIPPER_CONSIGNEE: "Forwarder/Shipper/Consignee",
        CUSTOMER_GROUP: "Customer Group",
        EXAM_FLAG: "Exam Flag",
        BAT_NO: "BAT No.",
        PAID_THROUGH_DATE: "Paid Through Date",
        REMARK1: "Remark1",
        REMARK2: "Remark2",
        REASON_FOR_RECOMMENDATION: "Reason For Recommendation",
        INITIATED_BY: "Initiated By",
        INITIATED_DATE: "Initiated Date",
        APPROVED_BY: "Approved By",
        APPROVED_DATE_TIME: "Approved Date/Time",
        NO_OF_WAIVED_DAYS: "No. of Waived Days",
        WAIVE: "% Waive",
        WAIVE_TYPE: "Waive Type",
        EXCEPTION_MSG: "Exception Msg",
        TIER_NO: "Tier No.",
        TIER_FROM_DATE_TIME: "Tier From Date/Time",
        TIER_TO_DATE_TIME: "Tier To Date/Time",
    },

    Edit: {
        REMARKS: "Remarks",
        NO_OF_WAIVED_DAYS: "No. of Waived Days",
        REASON_FOR_RECOMMENDATION: "Reason For Recommendation",
        WAIVE: "% Waive",
        BAT_NO: "BAT No.",
        REMARK1: "Remark1",
        REMARK2: "Remark2",
        CHARGING_DATE_FROM: "Charging From Date/Time",
        CHARGING_DATE_TO: "Charging To Date/Time",
        REASON_CODE: "Reason Code",
        WAIVE_TYPE: "Waive Type",
    }
}